import React, { useContext, useEffect } from 'react'
import { AccountsContext } from 'AccountsContext'
import './Modal.css'

const Modal = ({ header, content, primaryButton, secondaryButton, closeAction }) => {
  const {
    updateWidgetContainerClasses,
    updateCallingNumberFlag,
    updateFlagToShowSupportNumbers,
    updateFlagToShowFulfillmentMessage,
    updateFlagToShowCallbackModal,
    updateTripOptions,
    loadingHandler,
    previousOptionsAPIData,
    updateTripOptionsAPIData,
    previousStepOptionsData,
    tripOptionsAPIData,
    showCallingNumberModal,
    closeModal,
    callbackRequestData,
    callbackOptionsData,
    shouldCloseModal,
    callbackLoader,
    previousSettingsFlag,
    updatePreviousSettings,
    supportInputType,
  } = useContext(AccountsContext)

  const closeSubModal = () => {
    if (closeAction) {
      closeAction()
    }
    updateWidgetContainerClasses('support-widget-container push-left')
    updateCallingNumberFlag(false)
    updateFlagToShowSupportNumbers(false)
    updateFlagToShowFulfillmentMessage(false)
    updateFlagToShowCallbackModal(false)

    if (typeof secondaryButton.action === 'function') {
      secondaryButton.action()
    }

    if (shouldCloseModal) {
      closeModal()
    }
  }
  useEffect(() => {
    if (!showCallingNumberModal) {
      if (
        tripOptionsAPIData &&
        tripOptionsAPIData.level &&
        previousSettingsFlag &&
        previousStepOptionsData[tripOptionsAPIData.level]
      ) {
        updateTripOptionsAPIData(previousOptionsAPIData[tripOptionsAPIData.level])
        updateTripOptions(previousStepOptionsData[tripOptionsAPIData.level])
        updatePreviousSettings(false)
      }
      if (!callbackLoader) {
        loadingHandler(false)
      }
    }
  })

  const secondaryButtonAction = () => {
    if (typeof secondaryButton.action === 'function') {
      secondaryButton.action()
    }
    closeSubModal()
  }

  const primaryButtonAction = () => {
    if (typeof primaryButton.action === 'function') {
      primaryButton.action(callbackOptionsData, callbackRequestData, supportInputType)
    }
  }

  return (
    <React.Fragment>
      <div className="modal-box">
        <h6 className="modal-heading ta-c apt-10 apb-10 fw-500">
          <span className="fs-16"> {header} </span>
          <span className="close-modal" onClick={closeSubModal}>
            X
          </span>
        </h6>
        <div className="modal-content ta-c apl-15 apr-15 apb-10 lh-title">{content}</div>
        <If condition={secondaryButton.visible || primaryButton.visible}>
          <ul className="modal-actions flex flex-center">
            <If condition={secondaryButton.visible}>
              <li className="ta-c w-40p fw-700 br" onClick={secondaryButtonAction}>
                <button type="button" className="fw-700 fs-17 bn c-pointer tt-capitalize">
                  {secondaryButton.text}
                </button>
              </li>
            </If>
            <If condition={primaryButton.visible}>
              <li className="ta-c w-40p c-blue fw-700" onClick={primaryButtonAction}>
                <button type="button" className="fw-700 fs-17 bn  c-blue c-pointer tt-capitalize">
                  {primaryButton.text}
                </button>
              </li>
            </If>
          </ul>
        </If>
      </div>
    </React.Fragment>
  )
}

export default Modal
